
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BrandService } from '@/services/brand_service';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';

@Component
export default class SelectImagesModal extends Vue {
  visible = false;

  @lazyInject(BrandService)
  protected brandService!: BrandService;

  @Prop()
  wordTitleArray!: any[];

  @Prop()
  formData!: any;

  @Prop()
  shopId!: string;

  @Prop()
  headerImg: any;

  @Prop()
  headrtBList: any;

  @lazyInject(ShopService)
  shopService!: ShopService;

  listFormData = [];


  page = 1;

  lastPage = 0;

  loadType = false;

  lodoing = false;

  activeKey: any = '1';


  init() {
    this.visible = true;
    this.getList(this.wordTitleArray[0]);
    this.activeKey = this.wordTitleArray[0].type;
    this.wordTitle = this.wordTitleArray[0];
    const Blsit = this.headrtBList.map((item: any) => item.resource_id);
    if (this.headerImg && this.headerImg.length > 0) {
      this.selectedDatas = this.headerImg.filter((x: any) => x !== null && typeof x === 'object');
      this.selectedKeys = this.headerImg.map((item: any) => item?.resource_id).filter((item: any) => item !== undefined);
    } else {
      this.selectedKeys = [];
      this.selectedDatas = [];
    }
    this.selectedKeys = [...Blsit, ...this.selectedKeys];
  }

  async getList(data: any) {
    console.log(data);
    const params = {
      albumId: data.id,
      shopId: this.shopId,
      audit_status: 2,
      page: this.page,
      pageSize: 10,
    };
    console.log(params, data);
    this.listFormData = this.formData[data.type]?.add || [];

    if (data.id) {
      const res = await this.shopService.albumShopOfficialInfo(params);
      this.lodoing = false;
      console.log(res);
      this.listData = [...this.listData, ...res.list];
      this.lastPage = res.lastPage;
      if (this.page < this.lastPage) {
        this.loadType = true;
      } else {
        this.loadType = false;
      }
    } else {
      this.loadType = false;
      this.listData = [];
    }
  }

  isAssigned(id: number) {
    const ids = this.headrtBList.map((item: any) => item.resource_id);
    return ids.includes(id);
  }

  handleOk() {
    console.log(this.selectedKeys);
    const data = [...this.selectedDatas, ...new Array(5 - this.selectedKeys.length).fill(0)];
    this.visible = false;
    this.handleCancel();
    this.$emit('upload', data);
  }

  handleCancel() {
    this.visible = false;

    this.page = 1;

    this.lastPage = 0;

    this.loadType = false;

    this.lodoing = false;
    this.listData = [];
  }

  callback(key: string) {
    this.activeKey = key;
    const res = this.wordTitleArray.find((item: any) => item.type === key);
    this.page = 1;
    this.listData = [];
    this.wordTitle = res;
    this.getList(res);
  }

  wordTitle: any = '';

  listData: any = [];

  // 已选中的 key 数组
  selectedKeys: string[] = [];

  selectedDatas: any[] = [];
  handleCheck(key: string, data: any): void {
    console.log(key, this.selectedKeys);
    const index = this.selectedKeys.indexOf(key);
    if (index > -1) {
      // 已选中，取消
      this.selectedKeys.splice(index, 1);
      this.selectedDatas = this.selectedDatas.filter((item: any) => item.resource_id !== key);
    } else {
      // 未选中，加入
      if (this.selectedKeys.length >= 5) {
        this.$message.error('最多只能选择5张图片');
        return;
      }
      this.selectedKeys.push(key);
      this.selectedDatas.push(data);
    }
    console.log(this.selectedKeys);
  }

  loadMore() {
    this.page++;
    this.lodoing = true;
    this.getList(this.wordTitle);
  }
}
